// extracted by css-extract-rspack-plugin
var _1 = "V_6XlktM1LYehZs7";
export { _1 as "divider" }
// extracted by css-extract-rspack-plugin
var _1 = "V_6XlktM1LYehZs7";
export { _1 as "divider" }
